export default "__VITE_ASSET__f927d579__"